import { render, staticRenderFns } from "./DuringOtsComponent.vue?vue&type=template&id=c1ad6614&"
import script from "./DuringOtsComponent.vue?vue&type=script&lang=ts&"
export * from "./DuringOtsComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c1ad6614')) {
      api.createRecord('c1ad6614', component.options)
    } else {
      api.reload('c1ad6614', component.options)
    }
    module.hot.accept("./DuringOtsComponent.vue?vue&type=template&id=c1ad6614&", function () {
      api.rerender('c1ad6614', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/StudentDashboard/OfficerTrainingSchoolFlyout/DuringOtsComponent.vue"
export default component.exports